<template>
  <div>
    <taxablerebate-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import RebateSetupForm from "../../../components/payroll/taxablerebatesetup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "taxablerebate-form": RebateSetupForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setuptaxablerebate.createnewtaxablerebate'),
      pageTitleValue: "",
      formData: {
        rebatetypeid: null,
        rebatetypecode: null,
        rebatetypedesc: null,
        rebategroupid: null,
        rebategroupcode: null,
        rebategroupdesc: null,
        startdate: null,
        enddate: null,
        crcyid: null,
        rebatelimitamount: null,
        controlid: null,
        remark: null,
        stamp: null,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    //insert new record
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('post', {url: "/taxablerebatesetup/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "taxablerebatesetuplist" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "taxablerebatesetuplist" });
    },
  },
};
</script>